














import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class TradeSideBar extends Vue {

  public countRelocation:number = null;
  public countTransfer:number= null;
  public countTaking:number= null;

  public created() {
    this.$api.addEventListener('workflow',this.reload);
  }
  public destroyed() {
    this.$api.removeEventListener('workflow',this.reload);
  }
  public mounted(){
    this.reload();
  }
  public reload(){    
    this.$api.execute(new Common.TaskCountQuery('StockTaskCountQuery', false)).then(res =>{
      var hash = res as { [key: string]: number};
      this.countRelocation = hash.StockRelocation;
      this.countTransfer = hash.StockTransfer;
      this.countTaking = hash.StockTaking;
    });
  }

}
